// extracted by mini-css-extract-plugin
export default {"ag-styles":"R_g","container":"R_h","quoteBubbleTail":"R_dZ","orgContainer":"R_d0","avatar":"R_d1","name":"R_d2","orgIcon":"R_d3"};